import {
  ArrowForward,
  CalendarMonth,
  Celebration,
  CheckCircle,
  ChevronRight,
  Close,
  Description,
  EventAvailable,
  HomeWork,
  KeyboardArrowDown,
  LocationOn,
  Schedule,
  TrendingUp,
  WbSunny,
  WorkOutline
} from '@mui/icons-material';
import { useEffect, useMemo, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import './EmployeeDashboard.css';

const leaveBalances = [
  { name: 'Casual leave', short: 'CL', available: 7, total: 10, tone: 'mint' },
  { name: 'Sick leave', short: 'SL', available: 11, total: 14, tone: 'rose' },
  { name: 'Earned leave', short: 'EL', available: 16, total: 20, tone: 'violet' },
  { name: 'Compensatory off', short: 'CO', available: 2, total: 2, tone: 'amber' },
];

const week = [
  { day: 'Mon', date: 22, duration: '8h 18m', state: 'complete' },
  { day: 'Tue', date: 23, duration: '8h 04m', state: 'complete' },
  { day: 'Wed', date: 24, duration: '8h 26m', state: 'complete' },
  { day: 'Thu', date: 25, duration: '8h 11m', state: 'complete' },
  { day: 'Fri', date: 26, duration: '8h 02m', state: 'complete' },
  { day: 'Sat', date: 27, duration: 'Weekend', state: 'weekend' },
  { day: 'Sun', date: 28, duration: 'Weekend', state: 'weekend' },
];

const initialRequests = [
  { type: 'Earned leave', dates: '13 Oct - 15 Oct', days: '3 days', status: 'Pending', tone: 'pending' },
  { type: 'Casual leave', dates: '04 Sep', days: '1 day', status: 'Approved', tone: 'approved' },
];
const daytime = (() => {
  const hour = new Date().getHours();
  if (hour < 12) return 'morning';
  if (hour < 18) return 'afternoon';
  return 'evening';
})();

function formatClock(date) {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

function dateLabel(date) {
  return date.toLocaleDateString([], { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
}

function getDayCount(from, to) {
  if (!from || !to) return 0;
  const start = new Date(`${from}T00:00:00`);
  const end = new Date(`${to}T00:00:00`);
  const days = Math.floor((end - start) / 86400000) + 1;
  return days > 0 ? days : 0;
}

export default function EmployeeDashboard() {
  const [now, setNow] = useState(new Date());
  const [activeWorkspace, setActiveWorkspace] = useState('employee');
  const [isCheckedIn, setIsCheckedIn] = useState(true);
  const [checkInTime, setCheckInTime] = useState('09:14 AM');
  const [showLeaveForm, setShowLeaveForm] = useState(false);
  const [requests, setRequests] = useState(initialRequests);
  const [noticeOpen, setNoticeOpen] = useState(false);
  const [leaveForm, setLeaveForm] = useState({ type: 'Casual leave', from: '', to: '', reason: '' });

  const user = localStorage.getItem('user-name')
  const userFormatted = JSON.parse(user);

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  const leaveDays = useMemo(
    () => getDayCount(leaveForm.from, leaveForm.to),
    [leaveForm.from, leaveForm.to],
  );

  const handleCheckIn = () => {
    setIsCheckedIn((checkedIn) => {
      if (!checkedIn) setCheckInTime(formatClock(now));
      return !checkedIn;
    });
  };

  const handleLeaveSubmit = (event) => {
    event.preventDefault();
    if (!leaveForm.from || !leaveForm.to || !leaveDays) return;

    const from = new Date(`${leaveForm.from}T00:00:00`);
    const to = new Date(`${leaveForm.to}T00:00:00`);
    const dates = from.toLocaleDateString([], { day: '2-digit', month: 'short' })
      + (leaveForm.from === leaveForm.to ? '' : ` - ${to.toLocaleDateString([], { day: '2-digit', month: 'short' })}`);

    setRequests((items) => [{
      type: leaveForm.type,
      dates,
      days: `${leaveDays} ${leaveDays === 1 ? 'day' : 'days'}`,
      status: 'Pending',
      tone: 'pending',
    }, ...items]);
    setLeaveForm({ type: 'Casual leave', from: '', to: '', reason: '' });
    setShowLeaveForm(false);
  };

  return (
    <main className="employee-dashboard">
      <nav className="employee-dashboard__workspace-tabs" aria-label="Workspaces">
        <button
          type="button"
          className={`employee-dashboard__workspace-tab${activeWorkspace === 'employee' ? ' employee-dashboard__workspace-tab--active' : ''}`}
          aria-pressed={activeWorkspace === 'employee'}
          onClick={() => setActiveWorkspace('employee')}
        >
          Employee Workspace
        </button>
        <button
          type="button"
          className={`employee-dashboard__workspace-tab${activeWorkspace === 'admin' ? ' employee-dashboard__workspace-tab--active' : ''}`}
          aria-pressed={activeWorkspace === 'admin'}
          onClick={() => setActiveWorkspace('admin')}
        >
          ADMIN Workspace
        </button>
      </nav>

      {activeWorkspace === 'employee' ? (
        <>
      <section className="employee-dashboard__topbar">
        <div>
          <p className="employee-dashboard__eyebrow">Employee workspace</p>
          {/* <h1>Good {daytime}, {userFormatted.firstName}</h1> */}
          
        </div>
         <div className="employee-dashboard__top-actions">
        {/*  <button className="employee-dashboard__icon-button" type="button" aria-label="View notifications" onClick={() => setNoticeOpen((open) => !open)}>
            <NotificationsNone fontSize="small" />
            <span className="employee-dashboard__notification-dot" />
          </button>
          <button className="employee-dashboard__avatar-button" type="button" aria-label="Open account menu">
            <span>EH</span>
            <KeyboardArrowDown fontSize="small" />
          </button>*/}
          <p className="employee-dashboard__date">{dateLabel(now)} <span aria-hidden="true">|</span> {formatClock(now)}</p>
        </div> 
      </section>

      {/* {noticeOpen && (
        <aside className="employee-dashboard__notification-panel" aria-live="polite">
          <div className="employee-dashboard__panel-heading">
            <strong>Notifications</strong>
            <button type="button" aria-label="Close notifications" onClick={() => setNoticeOpen(false)}><Close fontSize="small" /></button>
          </div>
          <p><span className="employee-dashboard__notification-status" />Your October leave request is awaiting manager approval.</p>
          <p><span className="employee-dashboard__notification-status employee-dashboard__notification-status--soft" />Timesheet for this week is ready to submit.</p>
        </aside>
      )} */}

      <section className="employee-dashboard__hero">
        <div className="employee-dashboard__identity">
          <div className="employee-dashboard__profile-mark">EH<span className="employee-dashboard__online-dot" /></div>
          <div>
            <div className="employee-dashboard__identity-label">Employee profile</div>
            <h2>{userFormatted.fullName}</h2>
            <p>{userFormatted.designation || 'Officer'}<span aria-hidden="true">|</span> Employee ID-1036</p>
            <div className="employee-dashboard__profile-meta">
              <span><WorkOutline fontSize="inherit" /> ICT Deparment</span>
              <span><LocationOn fontSize="inherit" />Capital Market Stabilization Fund</span>
            </div>
          </div>
        </div>
        <div className="employee-dashboard__presence ">
          <div className="employee-dashboard__presence-copy" >
            {/* <span className={`employee-dashboard__presence-pill${isCheckedIn ? ' employee-dashboard__presence-pill--active' : ''}`}>
              <span />{isCheckedIn ? 'Working today' : 'Not checked in'}
            </span> */}
            {/* <strong>{isCheckedIn ? 'Your day is in motion' : 'Start your workday'}</strong> */}
            <h6 style={{textAlign: 'center'}}>{`Last Checked in at ${checkInTime}`}</h6>
          </div>
          {/* <button type="button" className={`employee-dashboard__check-button${isCheckedIn ? ' employee-dashboard__check-button--out' : ''}`} onClick={handleCheckIn}>
            <AccessTime fontSize="small" /> {isCheckedIn ? 'Check out' : 'Check in'}
          </button> */}
        </div>
      </section>

      <section className="employee-dashboard__quick-grid" aria-label="Today at a glance">
        <article className="employee-dashboard__quick-card employee-dashboard__quick-card--time">
          <div className="employee-dashboard__card-icon employee-dashboard__card-icon--teal"><Schedule /></div>
          <div><span>Hours today</span><strong>05h 42m</strong><small><TrendingUp fontSize="inherit" /> 42m ahead of yesterday</small></div>
        </article>
        <article className="employee-dashboard__quick-card">
          <div className="employee-dashboard__card-icon employee-dashboard__card-icon--orange"><HomeWork /></div>
          <div><span>Work mode</span><strong>Office</strong><small>Floor 8, Desk D-24</small></div>
        </article>
        <article className="employee-dashboard__quick-card">
          <div className="employee-dashboard__card-icon employee-dashboard__card-icon--purple"><EventAvailable /></div>
          <div><span>Next holiday</span><strong>16 Dec</strong><small>Victory Day <span aria-hidden="true">|</span> 78 days</small></div>
        </article>
        <article className="employee-dashboard__quick-card">
          <div className="employee-dashboard__card-icon employee-dashboard__card-icon--blue"><Description /></div>
          <div><span>Open requests</span><strong>{requests.filter((request) => request.status === 'Pending').length}</strong><small>Needs your attention</small></div>
        </article>
      </section>

      <section className="employee-dashboard__content-grid">
        <div className="employee-dashboard__main-column">
          <article className="employee-dashboard__surface employee-dashboard__leave-card">
            <div className="employee-dashboard__section-heading">
              <div><p>Time off</p><h2>Leave balance</h2></div>
              <button type="button" className="employee-dashboard__text-action" onClick={() => setShowLeaveForm(true)}>Request leave <ArrowForward fontSize="inherit" /></button>
            </div>
            <div className="employee-dashboard__leave-grid">
              {leaveBalances.map((leave) => {
                const usedPercent = Math.round(((leave.total - leave.available) / leave.total) * 100);
                return (
                  <div className="employee-dashboard__leave-item" key={leave.short}>
                    <div className={`employee-dashboard__leave-token employee-dashboard__leave-token--${leave.tone}`}>{leave.short}</div>
                    <div className="employee-dashboard__leave-copy">
                      <span>{leave.name}</span>
                      <strong>{leave.available}<small> / {leave.total} days</small></strong>
                      <div className="employee-dashboard__leave-track"><i className={`employee-dashboard__leave-fill employee-dashboard__leave-fill--${leave.tone}`} style={{ width: `${usedPercent}%` }} /></div>
                      <em>{leave.available} available</em>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="employee-dashboard__leave-footer"><CalendarMonth fontSize="small" /><span>Balances renew on 1 January 2027</span><RouterLink to="/app/leave-application">View leave history <ChevronRight fontSize="inherit" /></RouterLink></div>
          </article>

          <article className="employee-dashboard__surface employee-dashboard__attendance-card">
            <div className="employee-dashboard__section-heading">
              <div><p>Presence</p><h2>Attendance this week</h2></div>
              <button type="button" className="employee-dashboard__select-button">Sep 22 - Sep 28 <KeyboardArrowDown fontSize="small" /></button>
            </div>
            <div className="employee-dashboard__attendance-summary"><span><b>40h 01m</b> total time</span><span><b>8h 00m</b> daily average</span><span><b>100%</b> attendance</span></div>
            <div className="employee-dashboard__week-grid">
              {week.map((entry) => <div className={`employee-dashboard__day${entry.state === 'weekend' ? ' employee-dashboard__day--weekend' : ''}`} key={entry.day}>
                <span>{entry.day}</span><strong>{entry.date}</strong><i /><small>{entry.duration}</small>
              </div>)}
            </div>
            <div className="employee-dashboard__attendance-footer"><CheckCircle fontSize="small" /> Your attendance is on track this month. <button type="button">View attendance <ArrowForward fontSize="inherit" /></button></div>
          </article>
        </div>

        <aside className="employee-dashboard__side-column">
          <article className="employee-dashboard__surface employee-dashboard__event-card">
            <div className="employee-dashboard__section-heading"><div><p>Coming up</p><h2>My schedule</h2></div><button type="button" aria-label="View calendar" className="employee-dashboard__plain-icon"><CalendarMonth fontSize="small" /></button></div>
            <div className="employee-dashboard__event-date"><strong>30</strong><span>SEP<br />TUE</span></div>
            <div className="employee-dashboard__event-copy"><span className="employee-dashboard__event-time">10:00 AM - 10:45 AM</span><strong>Product weekly sync</strong><small>Design studio <span aria-hidden="true">|</span> 8 attendees</small></div>
            <div className="employee-dashboard__event-divider" />
            <div className="employee-dashboard__upcoming-event"><span>02 Oct</span><div><strong>Town hall</strong><small>All employees <span aria-hidden="true">|</span> 3:00 PM</small></div></div>
            <button type="button" className="employee-dashboard__full-action">Open calendar <ArrowForward fontSize="inherit" /></button>
          </article>

          <article className="employee-dashboard__surface employee-dashboard__requests-card">
            <div className="employee-dashboard__section-heading"><div><p>Requests</p><h2>Leave activity</h2></div><RouterLink to="/app/leave-application" className="employee-dashboard__plain-link">View all</RouterLink></div>
            <div className="employee-dashboard__request-list">
              {requests.slice(0, 3).map((request, index) => <div className="employee-dashboard__request-item" key={`${request.type}-${index}`}>
                <div className={`employee-dashboard__request-icon employee-dashboard__request-icon--${request.tone}`}><WbSunny fontSize="small" /></div>
                <div><strong>{request.type}</strong><span>{request.dates} <i aria-hidden="true">|</i> {request.days}</span></div>
                <em className={`employee-dashboard__request-status employee-dashboard__request-status--${request.tone}`}>{request.status}</em>
              </div>)}
            </div>
          </article>

          <article className="employee-dashboard__tip-card">
            <Celebration />
            <div><span>Team celebration</span><strong>Rafi's work anniversary is tomorrow</strong><button type="button">Send wishes <ArrowForward fontSize="inherit" /></button></div>
          </article>
        </aside>
      </section>

      {showLeaveForm && (
        <div className="employee-dashboard__modal-backdrop" role="presentation" onMouseDown={() => setShowLeaveForm(false)}>
          <section className="employee-dashboard__modal" role="dialog" aria-modal="true" aria-labelledby="leave-request-title" onMouseDown={(event) => event.stopPropagation()}>
            <button type="button" className="employee-dashboard__modal-close" aria-label="Close leave request" onClick={() => setShowLeaveForm(false)}><Close /></button>
            <p>Time off request</p><h2 id="leave-request-title">Plan your leave</h2>
            <form onSubmit={handleLeaveSubmit}>
              <label>Leave type<select value={leaveForm.type} onChange={(event) => setLeaveForm({ ...leaveForm, type: event.target.value })}>{leaveBalances.map((leave) => <option value={leave.name} key={leave.name}>{leave.name}</option>)}</select></label>
              <div className="employee-dashboard__modal-date-row"><label>From<input required type="date" min={new Date().toISOString().split('T')[0]} value={leaveForm.from} onChange={(event) => setLeaveForm({ ...leaveForm, from: event.target.value })} /></label><label>To<input required type="date" min={leaveForm.from || new Date().toISOString().split('T')[0]} value={leaveForm.to} onChange={(event) => setLeaveForm({ ...leaveForm, to: event.target.value })} /></label></div>
              <div className="employee-dashboard__day-count"><CalendarMonth fontSize="small" /> {leaveDays ? `${leaveDays} ${leaveDays === 1 ? 'day' : 'days'} requested` : 'Select your leave dates'}</div>
              <label>Reason<textarea rows="3" placeholder="Add a short note for your manager" value={leaveForm.reason} onChange={(event) => setLeaveForm({ ...leaveForm, reason: event.target.value })} /></label>
              <div className="employee-dashboard__modal-actions"><button type="button" onClick={() => setShowLeaveForm(false)}>Cancel</button><button type="submit">Submit request <ArrowForward fontSize="inherit" /></button></div>
            </form>
          </section>
        </div>
      )}
        </>
      ) : (
        <section className="employee-dashboard__admin-workspace" aria-label="Admin workspace">
          <div className="employee-dashboard__admin-heading">
            <p>Administration</p>
            <h1>ADMIN Workspace</h1>
            <span>Manage employee attendance, leave approvals, and holidays.</span>
          </div>
          <div className="employee-dashboard__admin-links">
            <RouterLink to="/app/employee-attendace" className="employee-dashboard__admin-link">
              <span><Schedule /></span>
              <div><strong>Attendance</strong><small>Review employee attendance</small></div>
              <ArrowForward fontSize="small" />
            </RouterLink>
            <RouterLink to="/app/leave-approval" className="employee-dashboard__admin-link">
              <span><EventAvailable /></span>
              <div><strong>Leave approvals</strong><small>Review and process leave requests</small></div>
              <ArrowForward fontSize="small" />
            </RouterLink>
            <RouterLink to="/app/hr-leave-approval" className="employee-dashboard__admin-link">
              <span><CheckCircle /></span>
              <div><strong>HR leave approvals</strong><small>Manage HR approval requests</small></div>
              <ArrowForward fontSize="small" />
            </RouterLink>
            <RouterLink to="/app/holiday-declare" className="employee-dashboard__admin-link">
              <span><CalendarMonth /></span>
              <div><strong>Holiday management</strong><small>Declare and manage holidays</small></div>
              <ArrowForward fontSize="small" />
            </RouterLink>
          </div>
        </section>
      )}
    </main>
  );
}
